<!-- begin #footer -->
<div id="footer" class="footer">
    &copy; 2020 Color sadaAdmin Responsive Admin Template - Sean Ngu All Rights Reserved
</div>
<!-- end #footer -->
